import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useState } from 'react';

import { FormInput, FormPanel } from 'components/FormPanel';

import Button from 'primitives/Button';
import { Dialog, DialogPanel, DialogSubTitle, DialogTitle } from 'primitives/Dialog';

const REQUEST_ESCROW_EXCEPTION_MUTATION = gql(`
  mutation RequestEscrowException($requestId: ID!, $note: String) {
    requestEscrowException(requestId: $requestId, note: $note) {
      id
      status
    }
  }
`);

const RequestEscrowExceptionButton: FC<{ requestId: string; onRequested: () => void }> = ({
  requestId,
  onRequested,
}) => {
  const [open, setOpen] = useState(false);

  const [requestException, { loading, error }] = useMutation(REQUEST_ESCROW_EXCEPTION_MUTATION);

  return (
    <>
      <Button variant="secondary" onClick={() => setOpen(true)}>
        Request escrow-direct exception
      </Button>
      {open ? (
        <Dialog open={true} onClose={() => setOpen(false)}>
          <DialogPanel>
            <DialogTitle>Request an escrow-direct exception</DialogTitle>
            <DialogSubTitle>
              Ask us to transfer the units directly out of the AngelList India Trust escrow account,
              without first opening a demat account in your own name. This needs sign-off from both
              our operations and legal teams, so it will add time to your request.
            </DialogSubTitle>
            <FormPanel
              loading={loading}
              error={error}
              onSubmit={data =>
                requestException({
                  variables: { requestId, note: data.note },
                }).then(result => {
                  if (result.data?.requestEscrowException) {
                    setOpen(false);
                    onRequested();
                  }
                })
              }
            >
              <FormInput
                fullWidth
                type="textarea"
                fieldName="note"
                label="Why can't you open your own demat account? *"
                helperText="Our operations and legal teams will review this before deciding"
                defaultValue=""
                validators={{ required: true }}
              />
            </FormPanel>
          </DialogPanel>
        </Dialog>
      ) : null}
    </>
  );
};

export default RequestEscrowExceptionButton;
